// extracted by mini-css-extract-plugin
export default {"wrapper":"reset-password_wrapper__dixze","text":"reset-password_text__6h8BD","btnWrapper":"reset-password_btnWrapper__6JmeU","firstBtn":"reset-password_firstBtn__XuzJ4"};